<template>
  <div class="pagination-component">
    <div class="pagination-component__show-more" v-if="currentPage < totalPages && isLoadMoreBtn">
      <button class="button pagination-component__show-more-btn" @click="showMore">
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.0607 4.9375C18.135 4.00606 17.0339 3.26695 15.821 2.76279C14.6081 2.25863 13.3074 1.99938 11.9937 2C6.46529 2 2 6.475 2 12C2 17.525 6.46529 22 11.9937 22C16.6592 22 20.5491 18.8125 21.6623 14.5H19.0607C18.5454 15.9619 17.5889 17.228 16.3231 18.1235C15.0573 19.0191 13.5446 19.5001 11.9937 19.5C7.85366 19.5 4.48906 16.1375 4.48906 12C4.48906 7.8625 7.85366 4.5 11.9937 4.5C14.07 4.5 15.9212 5.3625 17.272 6.725L13.2445 10.75H22V2L19.0607 4.9375Z" fill="#4E8AFF"/>
          </svg>
          {{ $t("Show more") }}
          <div v-if="isLoadMoreBtn" class="btn-preloader btn-preloader--gray"></div>
        </span>
      </button>
    </div>
    <div class="pagination-wrap" v-if="totalPages > 1 && totalCount > 0">
      <div class="page-item prev">
        <button :disabled="currentPage <= 1" v-if="shouldShowPrevButton" @click="goToPage(currentPage - 1)">
          <img src="/img/icons/chevron-left.svg" alt="chevron-left">
          {{ $t("Prev") }}
        </button>
      </div>
      <div class="pagination-wrap__items">
        <div class="page-item" v-for="page in pages" :key="page" :class="{ active: visiblePages.includes(page) }">
          <button @click="goToPage(page)">{{ page }}</button>
        </div>
      </div>
      <div class="page-item next">
        <button :disabled="currentPage >= totalPages" v-if="shouldShowNextButton" @click="goToPage(currentPage + 1)">
          {{ $t("Next") }}
          <img src="/img/icons/chevron-right.svg" alt="chevron-right">
        </button>
      </div>
      <!-- <div class="select" v-if="totalPages > 1 && totalCount > 0 && isPerPage">
        <CustomSelect :options="perPageOptions" :selectedValue="selectedPerPage.toString()"
          @customSelect2Change="updatePerPage" :selectId="'perPageSelect'" :selectName="'per-page'" />
      </div> -->
    </div>
  </div>
</template>

<script>
import CustomSelect from './CustomSelect.vue';

export default {
  components: {
    CustomSelect,
  },
  props: {
    totalCount: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    isLoadMoreBtn: {
      type: Boolean,
      default: false
    },
    maxPageItems: {
      type: Number,
      default: 6,
    },
    loadedPages: {
      type: Array,
      default: () => []
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    buttonsAlwaysVisible: {
      type: Boolean,
      default: false,
    },
    // offersMeta: {
    //   type: Object,
    //   default: () => ({})
    // }
  },
  data() {
    return {
      perPageOptions: [
        { value: '96', text: '96' },
        { value: '48', text: '48' },
        { value: '24', text: '24' },
        { value: '12', text: '12' },
        { value: '6', text: '6' },
      ],
      selectedPerPage: this.perPage,
      visiblePages: [this.currentPage],
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.selectedPerPage);
    },
    shouldShowPrevButton() {
      if(this.buttonsAlwaysVisible) return true;
      return this.currentPage > 1;
    },
    shouldShowNextButton() {
      if(this.buttonsAlwaysVisible) return true;
      return this.currentPage < this.totalPages;
    },
    pages() {
      const pages = [];
      const pagesBefore = [];
      const pagesAfter = [];
      const current = this.currentPage;
      const maxPage = this.totalPages;
      const maxPageItems = this.maxPageItems;

      pages.push(1);

      if (maxPage <= maxPageItems) {
        for (let i = 2; i <= maxPage; i++) {
          pages.push(i);
        }
        return pages;
      }

      const middleCount = maxPageItems - 2;
      const half = Math.floor(middleCount / 2);

      let start = current - half;
      let end = current + half;

      if (start < 2) {
        start = 2;
        end = start + middleCount - 1;
      }

      if (end > maxPage - 1) {
        end = maxPage - 1;
        start = end - middleCount + 1;
        if (start < 2) start = 2;
      }

      for (let i = start; i < current; i++) {
        pagesBefore.push(i);
      }

      pages.push(...pagesBefore);
      if (current !== 1 && current !== maxPage) {
        pages.push(current);
      }

      for (let i = current + 1; i <= end; i++) {
        pagesAfter.push(i);
      }

      pages.push(...pagesAfter);

      if (!pages.includes(maxPage)) {
        pages.push(maxPage);
      }

      return pages;
    }
  },
  methods: {
    goToPage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.visiblePages = [page];
        this.$emit('update-page', {page: page, showMore: false});
      }
    },
    updatePerPage(value) {
      this.selectedPerPage = parseInt(value);
      this.$emit('update-per-page', this.selectedPerPage);
    },
    showMore() {
      this.visiblePages = [...this.visiblePages, this.currentPage + 1];
      this.$emit('update-page', {page: this.currentPage + 1, showMore: true});
    },
    handlePaginationPageLoaded(pages) {
      this.visiblePages = pages;
    }
  },
  watch: {
    selectedPerPage(){
      this.$emit('update-per-page', this.selectedPerPage);
    },
    perPage(newVal) {
      this.selectedPerPage = newVal;
    },
    currentPage(newVal) {
      if (!this.visiblePages.includes(newVal)) {
        this.visiblePages.push(newVal);
      }
    },
    loadedPages(newVal) {
      this.visiblePages = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.pagination-component{
  display: flex;
  flex-direction: column;
  gap: 15px;
  &__show-more{
    .button {
      max-width: unset;
      background-color: #fff;
      padding: 0;
      height: 46px;
      font-size: 14px;
      user-select: none;
      width: 100%;
      display: block;
      border: 1px solid #fff;
      transition: 0.4s all;
      &:hover{
        border: 1px solid #E5E5E5;
      }
      &:after {
        background-color: #2b3545;
      }

      .btn-preloader {
        background-color: #2b3545;
      }

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        z-index: 2;
        gap: 10px;
        font-family: "Avenir-Next-DemiBold", sans-serif;
        font-weight: 100;
        font-size: 14px;
        line-height: 140%;
        letter-spacing: 0px;
        text-align: center;
        vertical-align: middle;
        text-transform: uppercase;
        color: #4E8AFF;
      }
    }
  }
}

.pagination-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  &__items{
    display: flex;
    align-items: center;
    gap: 5px; 
  }
  .page-item {
      
      button,
      span {
        color: #9D9D9D;
        font-size: 14px;
        line-height: 140%;
        font-family: "Avenir-Next-DemiBold", sans-serif;
        font-weight: 100;
        padding: 10px;
        background-color: #fff;
        border-radius: 8px;
        transition: 0.4s all;
        height: 40px;
        min-height: 40px;
        min-width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;
        border: 1px solid #fff;
      }

      &.active {
        button,
        span {
          background-color: #4E8AFF;
          border-color: #4E8AFF;
          cursor: unset;
          color: #fff;
        }
      }

      &:hover:not(.active) {
        button,
        span {
          border: 1px solid #E5E5E5;
          color: #505050;
        }
      }

      &.disabled {
        display: none;
      }

      &.prev,
      &.next {
        min-width: 80px;
        @media only screen and (max-width: 768px) {
          min-width: 40px;
        }
        button {
          display: flex;
          align-items: center;
          gap: 5px;
          &:disabled{
            opacity: 0.6 !important;
          }
        }
      }
    }
  /* Styling for custom select dropdown */
  :deep(.select) {
    position: absolute;
    right: 0;
    top: 0;
    width: 120px;

    .custom-select-wrap {
      .fake-select {
        padding: 3px 20px;
        z-index: 1;
      }

      .options-list-wrap {
        top: unset;
        bottom: 45px;

        .options-list {
          display: flex;
          flex-direction: column-reverse;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .pagination {
      margin: 0;
    }

    .select {
      width: 100%;
      margin-top: 10px;
      position: static;
    }
  }

  @media only screen and (max-width: 520px) {

    .next,
    .prev {
      button {
        font-size: 0 !important;
        gap: 0 !important;
      }
    }
  }
}
</style>
